<template>
  <div class="header-nav">
    <!-- 顶部导航 -->
    <div class="index-nav">
      <div class="index-nav-group">
        <div class="group-left">
          <div class="index-nav-item animated lightSpeedIn active">
            <!-- <router-link to="/">{{$t("home")}}</router-link> -->
            <a @click="scrollTo('index')">{{ $t("home") }}</a>
          </div>
          <div v-if="isMobile" class="index-nav-item">|</div>
          <div class="index-nav-item animated lightSpeedIn">
            <a @click="scrollTo('video')">{{ $t("video") }}</a>
          </div>
          <div v-if="isMobile" class="index-nav-item">|</div>
          <div class="index-nav-item animated lightSpeedIn">
            <a @click="scrollTo('generals')">{{ $t("role") }}</a>
          </div>
          <div v-if="isMobile" class="index-nav-item">|</div>
          <div class="index-nav-item animated lightSpeedIn">
            <a @click="scrollTo('strategicmap')">{{ $t("map") }}</a>
          </div>
          <div v-if="isMobile" class="index-nav-item">|</div>
          <div class="index-nav-item animated lightSpeedIn">
            <a @click="scrollTo('description')">{{ $t("summary") }}</a>
          </div>
          <!-- 新闻 -->
          <div v-if="!isMobile" class="index-nav-item animated lightSpeedIn">
            <router-link class="btn-new" to="/secondary">
              <span v-show="news"></span>
            </router-link>
          </div>
          <ShopButtonVue
            v-if="!isMobile"
            :lang="lang"
            class="index-nav-item animated lightSpeedIn"
          />
        </div>
        <div class="index-nav-item animated lightSpeedIn lang-box">
          <select v-model="lang" @change="changeLang">
            <option value="zh-CN">繁體中文</option>
            <option value="ja">日本語</option>
            <option value="en">English</option>
            <option value="th">ภาษาไทย</option>
          </select>
        </div>
      </div>
    </div>
    <!-- fb -->
    <div class="download-box">
      <div class="download-fb" v-if="lang == 'zh-CN'">
        <a
          class="btn-fb"
          target="_blank"
          href="https://www.facebook.com/zgbwu/"
        ></a>
        <a class="btn-bird" href="#"></a>
      </div>
      <div class="download-fb" v-if="lang == 'ja'">
        <a
          class="btn-fb"
          target="_blank"
          href="https://www.facebook.com/sengokufubu/"
        ></a>
        <a
          class="btn-bird"
          target="_blank"
          href="https://twitter.com/sengokufubu"
        ></a>
      </div>
      <div class="download-fb" v-if="lang == 'en'">
        <a
          class="btn-fb"
          target="_blank"
          href="https://www.facebook.com/sengokufubu.en"
        ></a>
        <a class="btn-bird" href="#"></a>
      </div>
      <div class="download-fb" v-if="lang == 'th'">
        <a
          class="btn-fb"
          target="_blank"
          href="https://www.facebook.com/sengokufubu.th/"
        ></a>
        <a class="btn-bird" target="_blank" href="#"></a>
      </div>
    </div>
  </div>
</template>

<script>
import ShopButtonVue from "./ShopButton.vue";

export default {
  name: "Header",
  components: {
    ShopButtonVue
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    cdnPrefix: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      lang: localStorage.getItem("localeLanguage") || "en",
      isMove: false,
      news: true //有新的公告
    };
  },
  mounted() {
    let rotate = 0;
    let that = this;
    //点击顶部导航条
    $(".index-nav-group .index-nav-item").on("click", function() {
      $(".index-nav-group .index-nav-item").removeClass("active");
      $(this).addClass("active");
      if (this.isMobile) {
        return;
      }
      // 旋转fb
      rotate = rotate ? (rotate += 360) : (rotate -= 360);
      $(".download-fb").css({
        transform: `rotateY(${rotate}deg)`
      });
    });
    //页面滚动时顶部导航条切换
    if (document.body.offsetWidth > 768) {
      $("#main").scroll(function() {
        //判断是否在滚动，如果没有，则支执行这里的代码
        if (!that.isMove) {
          //获取滚动距离
          let _scrollTop = $("#main").scrollTop();
          // 5个菜单按钮
          let i = Math.round(_scrollTop / document.body.offsetHeight);
          i = i > 4 ? 4 : i;
          $(`.index-nav-group .index-nav-item`).removeClass("active");
          $(`.index-nav-group .index-nav-item:nth(${i})`).addClass("active");
        }
      });
    }
    // 小屏适配
    if (document.documentElement.clientWidth <= 768) {
      $(".index-nav-group").css("height", "50px");
      document.onclick = function(e) {
        $(".index-nav-group").css("height", "50px");
      };
      $(".index-nav-group").on("click", function(e) {});
    }
  },
  methods: {
    changeNavCollapse(e) {
      $(e.currentTarget).toggleClass("active");
      if ($(".index-nav-group").css("height") == "50px") {
        $(".index-nav-group").css("height", "240px");
      } else {
        $(".index-nav-group").css("height", "50px");
      }
      this.stopFunc(e);
    },
    download_fb() {
      alert("fb");
    },
    download_bird() {
      alert("bird");
    },
    stopFunc(e) {
      e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = true);
    },
    changeLang(e) {
      window.localStorage.setItem("localeLanguage", e.target.value);
      location.reload(false);
    },
    scrollTo(elemId) {
      let h = document.getElementById(elemId).offsetTop;
      if (this.isMobile) {
        h -= 100;
        window.scrollTo({
          top: h,
          behavior: "smooth"
        });
      } else {
        document.getElementById("main").scrollTo({
          top: h,
          behavior: "smooth"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@keyframes active_news {
  0% {
    background: url($cdnPrefix+"/imgs/tip-news-normal.png") center no-repeat;
    background-size: 150%;
  }
  50% {
    background: url($cdnPrefix+"/imgs/tip-news-light.png") center no-repeat;
    background-size: 150%;
  }
  100% {
    background: url($cdnPrefix+"/imgs/tip-news-normal.png") center no-repeat;
    background-size: 150%;
  }
}
.header-nav {
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  .index-nav {
    background: url($cdnPrefix+"/imgs/header-bg.png") center top no-repeat;
    background-size: 100% 100%;
    .index-nav-group {
      height: 70px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      overflow: hidden;
      transition: all 0.2s linear;
      padding-bottom: 5px;
      .group-left {
        height: 100%;
        padding-left: 100px;
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 5%;
        flex-wrap: nowrap;
        overflow: hidden;
      }
      .index-nav-item {
        text-align: center;
        a {
          color: #fff;
          display: block;
          font-size: 22px;
          font-weight: 400;
        }
        .btn-new {
          width: 140px;
          height: 70px;
          position: relative;
          span {
            display: block;
            width: 40px;
            height: 40px;
            position: absolute;
            right: -10px;
            top: 2px;
            background: url($cdnPrefix+"/imgs/tip-news-light.png") center
              no-repeat;
            background-size: 100%;
            animation: "active_news" 0.8s linear infinite;
          }
        }
      }
      .active a,
      a:hover {
        color: #f8da6c;
      }
      .index-nav-item.lang-box {
        padding: 0 20px;
        select {
          width: 120px;
          height: 38px;
          border-radius: 5px;
          background: #623025;
          border: 1px solid #fff;
          color: #fff;
          padding: 0 10px;
          font-size: initial;
          cursor: pointer;
          outline: none;
          option {
            cursor: pointer;
          }
        }
      }
    }
  }
  .download-box {
    position: absolute;
    top: 100%;
    right: 120px;
    perspective: 2000px;
    width: 55px;
    height: 200px;
    z-index: 100;
    .download-fb {
      position: absolute;
      top: 0;
      right: 0;
      background: url($cdnPrefix+"/imgs/right-top-fb.png") no-repeat center top;
      background-size: 100%;
      width: 55px;
      height: 200px;
      transition: all 1s linear;
      transform: rotateY(0deg);
      a {
        display: block;
        height: 50px;
        cursor: pointer;
      }
      .btn-fb {
        margin-top: 26px;
      }
      .btn-bird {
        margin-top: 15px;
      }
    }
  }
}
// 多语言
.lang-zh-CN {
  .btn-new {
    background: url($cdnPrefix+"/imgs/btn-new-cn.png") center no-repeat;
    background-size: 140px;
  }
}
.lang-ja {
  .btn-new {
    background: url($cdnPrefix+"/imgs/btn-new-jp.png") center no-repeat;
    background-size: 140px;
  }
}
.lang-en {
  .btn-new {
    background: url($cdnPrefix+"/imgs/btn-new-en.png") center no-repeat;
    background-size: 140px;
  }
}
.lang-th {
  .btn-new {
    background: url($cdnPrefix+"/imgs/btn-new-th.png") center no-repeat;
    background-size: 140px;
  }
}
@media screen and (max-width: 1140) {
  .header-nav {
    .index-nav {
      .index-nav-group {
        .group-left {
          padding-left: 0;
        }
      }
    }
  }
}
// 适配小屏
@media screen and (max-width: 768px) {
  .header-nav {
    .index-nav {
      height: 50px;
      padding: 0;
      .index-nav-group {
        height: 50px;
        overflow: hidden;
        justify-content: space-around;
        .index-nav-item {
          height: 45px;
          line-height: 45px;
          margin: 0;
          a {
            font-size: 16px;
          }
          .btn-new {
            width: 100px;
            height: 30px;
            position: relative;
            top: 8px;
            span {
              width: 25px;
              height: 25px;
              right: 13px;
              top: 2px;
            }
          }
        }
        .index-nav-item:last-child {
          height: 35px;
          display: none;
        }
      }
    }
    .download-box {
      display: none;
    }
  }
  .lang-zh-CN {
    .btn-new {
      background: url($cdnPrefix+"/imgs/btn-new-cn.png") left center no-repeat;
      background-size: 80px;
    }
  }
  .lang-ja {
    .btn-new {
      background: url($cdnPrefix+"/imgs/btn-new-jp.png") left center no-repeat;
      background-size: 80px;
    }
  }
  .lang-en {
    .btn-new {
      background: url($cdnPrefix+"/imgs/btn-new-en.png") left center no-repeat;
      background-size: 80px;
    }
  }
  .lang-th {
    .btn-new {
      background: url($cdnPrefix+"/imgs/btn-new-th.png") left center no-repeat;
      background-size: 80px;
    }
  }
}
@media screen and (max-width: 414px) {
  .header-nav {
    .index-nav {
      .index-nav-group {
        padding: 0 10px;
        .index-nav-item {
          a {
            font-size: 14px;
          }
        }
        .index-nav-item:last-child {
          display: none;
        }
      }
    }
    .download-box {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue